import AdminPage from "@/pages/AdminPage";

export default function AdminCmsPage() {
  return <AdminPage initialTab="pages" />;
}

